import {ActionBarWrapper} from "@/components/actionBarWrapper/ActionBarWrapper.tsx";
import {FilterCategory, FilterSets} from "@/components/filterDropdown/FilterDropdown.ts";
import {SearchInput} from "@/components/searchInput/SearchInput.tsx";
import {MaintenanceSchedulesFilters} from "@/pages/maintenance/maintenance-dashboard/tabs/schedules/MaintenanceSchedulesTable/components/MaintenanceSchedulesFilters.tsx";

interface MaintenanceSchedulesControlBarProps {
  search: string;
  setSearch: (search: string) => void;
  filterSets: FilterSets<FilterCategory>;
  onFilterSetChange: (filterSet: FilterSets<FilterCategory>) => void;
}

export const MaintenanceSchedulesControlBar = ({
  search,
  setSearch,
  filterSets,
  onFilterSetChange,
}: MaintenanceSchedulesControlBarProps) => {
  return (
    <ActionBarWrapper
      className="mb-3"
      left={
        <>
          <SearchInput value={search} onChange={setSearch} variant="tableControlBar" />
          <MaintenanceSchedulesFilters filterSets={filterSets} onFilterSetChange={onFilterSetChange} />
        </>
      }
    />
  );
};
